import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bba4a28")

_pushScopeId("data-v-6bba4a28")
const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "display-flex justify-content-between" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = {
  key: 0,
  class: "search-form-item"
}
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = {
  key: 1,
  class: "search-form-item"
}
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = {
  key: 2,
  class: "search-form-item"
}
const _hoisted_9 = {
  key: 3,
  class: "search-form-item"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "justify-content-end margin-right20px"
}
const _hoisted_12 = { class: "display-flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_add_button = _resolveComponent("add-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_apartment_edit_dialog = _resolveComponent("apartment-edit-dialog")
  const _component_department_set_dialog = _resolveComponent("department-set-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadCrumb }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.projectType==='community')
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.DeviceDetailDetailUnitName), 1),
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.listRequestData.param.Build,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.Build = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_cus_option, {
                      value: "all",
                      label: _ctx.$wordList.SelectAll
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.projectType==='community')
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.RDeviceSearchLabelRoomName), 1),
                _createVNode(_component_cus_select, {
                  modelValue: _ctx.listRequestData.param.Apt,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.Apt = $event))
                }, {
                  default: _withId(() => [
                    _createVNode(_component_cus_option, {
                      value: "all",
                      label: _ctx.$wordList.SelectAll
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_cus_option, {
                        key: item.key,
                        value: item.key,
                        label: item.value
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.projectType==='community')
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listRequestData.param.Key,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listRequestData.param.Key = $event)),
                  placeholder: _ctx.ChangeWordList.PMPlaceHolderName
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : (_ctx.projectType==='office')
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.listRequestData.param.DepartmentName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.listRequestData.param.DepartmentName = $event)),
                    placeholder: _ctx.ChangeWordList.PMPlaceHolderName
                  }, null, 8, ["modelValue", "placeholder"])
                ]))
              : _createCommentVNode("", true),
          _createVNode(_component_cus_button, { onClick: _ctx.searchList }, {
            default: _withId(() => [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        (_ctx.projectType === 'office')
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_add_button, {
                  onClick: _ctx.addDepartment,
                  class: "margin-top10px"
                }, null, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.listRequestData,
        showDefaultAction: [],
        update: _ctx.updateToList,
        saveParamInPath: _ctx.saveParamInPath,
        isSaveParamInPathInRow: true,
        showCheck: false,
        action: _ctx.action
      }, {
        AptNumberSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSortRes('pmComApartment', 'Apt')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('pmComApartment', 'Apt')
            }, null, 8, ["src"])
          ])
        ]),
        AptNameSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getSortRes('pmComApartment', 'RoomNumber')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('pmComApartment', 'RoomNumber')
            }, null, 8, ["src"])
          ])
        ]),
        DepartmentNameSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getSortRes('pmOfficeDepartment', 'UnitName')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('pmOfficeDepartment', 'UnitName')
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }, 8, ["headers", "requestData", "update", "saveParamInPath", "action"]),
      (_ctx.isShowApartmentEditDialog)
        ? (_openBlock(), _createBlock(_component_apartment_edit_dialog, {
            key: 0,
            onSuccess: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateToList++)),
            "init-form": _ctx.communityFormData,
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowApartmentEditDialog=false))
          }, null, 8, ["init-form"]))
        : _createCommentVNode("", true),
      (_ctx.isShowDepartmentSetDialog)
        ? (_openBlock(), _createBlock(_component_department_set_dialog, {
            key: 1,
            onSuccess: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateToList++)),
            onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowDepartmentSetDialog=false)),
            initForm: _ctx.officeFormData,
            operate: _ctx.operate
          }, null, 8, ["initForm", "operate"]))
        : _createCommentVNode("", true)
    ])
  ]))
})